import { cn } from '@ifixit/ui/lib/utils';
import { SearchResultItem } from '../../types';
import { getImageUrl, getTitle, getImageSubtext } from '../../utils';
import { ResultImage } from './result-image';
import { ResultContent } from './result-content';
import { type LocaleCode } from '@ifixit/i18n';
import { Doctype } from '../../types/indices';

interface SearchResultCardProps {
   hit: SearchResultItem;
   className?: string;
   currency: string;
   localeCode: LocaleCode;
   storeCode: string;
}

/**
 * Main component to display a search result card
 */
export function SearchResultCard({
   hit,
   className,
   currency,
   localeCode,
   storeCode,
}: SearchResultCardProps) {
   const url = hit.url || hit.permalink || '';
   const imageUrl = getImageUrl(hit);
   const imageSubtext = getImageSubtext(hit);
   const doctype = hit.doctype as Doctype;
   const title = getTitle(hit);

   return (
      <div
         className={cn(
            'flex flex-col items-start self-stretch bg-white border border-gray-300',
            'sm:rounded-xl',
            className
         )}
      >
         <a
            href={url}
            className={cn(
               'flex items-center gap-3 self-stretch p-4 hover:bg-gray-50 w-full !no-underline !hover:no-underline',
               'sm:rounded-xl'
            )}
         >
            <div className="flex flex-col items-start gap-2.5 w-16">
               <ResultImage
                  imageUrl={imageUrl}
                  title={title}
                  doctype={doctype}
                  imageSubtext={imageSubtext}
               />
            </div>
            <div className="flex items-center gap-3 grow">
               <div className="flex flex-col justify-center items-start gap-1.5 grow">
                  <ResultContent
                     hit={hit}
                     currency={currency}
                     localeCode={localeCode}
                     storeCode={storeCode}
                  />
               </div>
            </div>
         </a>
      </div>
   );
}
